import {Intro, type IntroProps} from '../../generic/Intro/Intro'
import {ColorDivider} from '../../generic/ColorDivider/ColorDivider'

import Styles from './IntroSection.module.css'

export type IntroSectionProps = IntroProps

export type IntroSectionPropsData = Omit<IntroSectionProps, 'loggedIn' | 'isOrgAdmin' | 'monaHead'>

export const defaultProps: Partial<IntroSectionProps> = {}

export const IntroSection = (props: IntroSectionProps) => {
  const initializedProps: IntroSectionProps = {...defaultProps, ...props}

  return (
    <div className={Styles['IntroSection']}>
      <Intro {...initializedProps} />
      <ColorDivider variant="1" />
    </div>
  )
}
